//import {Link, useParams} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, consoleLog} from '../../../utils/functions';
import {UserContext} from '../../../utils/usercontext';
import EventEmitter from '../../../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import '../fontawesome/fontawesome';
import CopyBox from '../bbcode/copybox';

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
//import Modal from 'react-bootstrap/Modal';

//import './css/index.css';
//import './css/header.css';

export default class PortalAdminInvitesComponent extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			service: {
				show: false,
				id: this.props.service,
				mode: this.props.mode,
			},
			invites: [],
			isOpen: false,
			admins: [0, 0],
			members: [0, 0],
			title: '',
		};
		this.getInvites = this.getInvites.bind(this);
		this.stationInvites = this.stationInvites.bind(this);
		this.inviteStatus = this.inviteStatus.bind(this);
  };

  async componentDidMount() {
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );

		EventEmitter.emit('/client', {data: 'no value'});

		/*const y = await value.setWorker( this.props.service );
		let server = value.worker[this.props.service] || y[this.props.service];
		

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi(`${server}/v3/admin/admin`, params);
		consoleLog(x.data);

		let service = this.state.service;
		service.status = true;
		service.name = x.data.servicename;
		x.data.overview.shorttitle = x.data.description.title;
		this.setState({service, overview: x.data.overview});
		setTitle('Invites', x.data.servicename);*/
		//this.setState({status: true, services: x.data.Services});
		

		/*
		let params = new URLSearchParams();
		const x = await postApi('/v3/index', params);
		
		//this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});
		*/

		this.getInvites();
	}

	componentWillUnmount() {
	}


	async getInvites() {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		const x = await postApi('/v3/portal/invites', params);
		console.log(x.data);
		let service = this.state.service;
		service.show = true;
		if( x.status === 200 ) {
			this.setState({invites: []},()=>{
				this.setState({service, invites: x.data.invites, isOpen: x.data.isOpen, admins: x.data.admins, members: x.data.members, title: x.data.title});
			});
		}
	}


	async stationInvites() {
		let isOpen = 1 - this.state.isOpen;

		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('isOpen', isOpen);
		await putApi('/v3/portal/radioinvites', params);

		//this.setState({isOpen});
		await this.getInvites();


	}


	async inviteStatus(id, status) {
		let params = new URLSearchParams();
		params.append('service', this.state.service.id);
		params.append('id', id);
		params.append('status', status);
		const x = await putApi('/v3/portal/invites', params);
		
		if( x.status === 200 ) {
			this.getInvites();
		}
	}

	render() {
		//const user = this.context;

		const invites = this.state.invites.map((e,i) => {
			return (
				<Col md={6} key={i}>
          <div className="card custom-card">
						<div className="card-header">
							<div className="d-flex align-items-center w-100">
								<div className="me-2">
									<span className="avatar avatar-rounded">
										<img src={`https://cloud.ultrastream.io${e.avatar}?d=${Math.floor(Date.now()/1000)}`} alt="img" />
									</span>
								</div>
								<div className="">
									<div className="fs-15 fw-semibold">{e.title?<>{e.username} ({e.title})</>:e.username}</div>
									<p className="mb-0 text-muted fs-11">{moment(new Date(e.mtime)).format("L  LT")}</p>
								</div>
								{/*<div className="dropdown ms-auto">
									{e.status === 0 && <Button size="sm" variant="info" disabled={true}>Waiting Approval</Button>}
									{e.status === 1 && <Button size="sm" variant="success" disabled={true}>Invite Approved</Button>}
									{e.status === 2 && <Button size="sm" variant="danger" disabled={true}>Invite Declined</Button>}
								</div>*/}
                <div className="dropdown ms-auto">
								{e.status === 0 &&
									<ButtonGroup size="sm">
										<Button variant="success" onClick={()=>this.inviteStatus(e.id, 1)}><FontAwesomeIcon icon="check" />&nbsp;Accept</Button>
										<Button variant="danger" onClick={()=>this.inviteStatus(e.id, 2)}><FontAwesomeIcon icon="xmark" />&nbsp;Decline</Button>
									</ButtonGroup>
								}

								{e.status === 1 &&
									<ButtonGroup size="sm">
										<Button variant="success" disabled={true}><FontAwesomeIcon icon="check"/>&nbsp;Accepted</Button>
										
									</ButtonGroup>
								}

								{e.status === 2 &&
									<ButtonGroup size="sm">
										<Button variant="danger" disabled={true}><FontAwesomeIcon icon="xmark"/>&nbsp;Declined</Button>
									</ButtonGroup>
								}
								
							</div>
							</div>
						</div>
						<div className="card-body">
							{e.status > 0 &&
								<ul className="list-group ">
									<li className="list-group-item d-flex justify-content-between align-items-start">
										<div className="ms-2 me-auto text-muted">
											<div className="fw-semibold fs-14 text-default">
												{e.status===1?'Accepted':'Declined'} by </div>
											{e.admin_title?e.admin_title:e.admin_username}
										</div>
									</li>
								</ul>
							}
							<ol className="list-group list-group-numbered">
								
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Fullname:</div>
										{e.fullname?e.fullname:'Name not provided'}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Facebook Profile Page:</div>
										{e.facebook?e.facebook:'Facobook page not provided'}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">DJ'ing Experience:</div>
										{e.djing}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Broadcasting Experience:</div>
										{e.broadcasting}
									</div>
								</li>
								<li className="list-group-item d-flex justify-content-between align-items-start">
									<div className="ms-2 me-auto text-muted">
										<div className="fw-semibold fs-14 text-default">Link to previous set:</div>
										{e.previous?e.previous:'Link to previous set not provided'}
									</div>
								</li>
							</ol>
						</div>
					</div>
				</Col>
			)
		});

		return (
			<>
				{( this.state.service.show === true && this.state.service.mode === 'full' ) &&
					<Col xs={12}>
						<div className="card custom-card custom-frame">
							<div className="card-header justify-content-between">
								<div className="card-title">
									{this.state.service.name}
								</div>
								<div className="dropdown d-flex">
									<ButtonGroup size="sm">
										<Button size="sm" variant={this.state.isOpen===1?'success':'danger'} onClick={()=>this.stationInvites()}><FontAwesomeIcon icon={this.state.isOpen===1?'check':'times'} />&nbsp;Invites {this.state.isOpen===1?'Open':'Closed'}</Button>
										<Button size="sm" variant="success" onClick={()=>this.invite()}><FontAwesomeIcon icon="plus" />&nbsp;Invite DJ</Button>
									</ButtonGroup>
								</div>
							</div>
							<div className="card-body">
								<Row>
									<Col>
										Invites: {this.state.isOpen===1?'Open':'Closed'}<br />
										Admins: {this.state.admins[0]} of {this.state.admins[1]}<br />
										Members: {this.state.members[0]} of {this.state.members[1]>0?this.state.members[1]:'unlimited'}<br />
										<br />
										
										{this.state.isOpen === 1 ?
											<>
												Please share the following link to advertise and invite DJ's to join your station:<br /><br />
												<CopyBox content={`https://ultrastream.io/radio/${this.state.title}`} />
											</>
										:
											<>
												You will need to open invites before anyone can join your station.<br /><br />
												{(this.state.title === '' ) &&
													<div className="alert alert-danger" role="alert">
														Please set a station title before advertising.
													</div>
												}
												{(this.state.members[1] > 0 && this.state.members[0] >= this.state.members[1]) &&
													<div className="alert alert-danger" role="alert">
														You have reached maximum number of DJ's in this station.
													</div>
												}
											</>
										}
										{/*<a href={`https://ultrastream.io/radio/${this.state.overview.shorttitle.replaceAll(' ','-')}`} target="_blank" rel="noreferrer">https://ultrastream.io/radio/{this.state.overview.shorttitle.replaceAll(' ','-')}</a>*/}
									</Col>
								</Row>
							</div>
						</div>
					</Col>
				}
				{invites}
			</>
		);
	}
}

